import { createContext, FunctionComponent, ReactNode } from 'react';
import { PathsConfiguration } from './interfaces/PathsConfiguration';

export const RuntimeContext = createContext<PathsConfiguration>({
    app: {
        ui: {
            urlBase: '',
            talentDevOrigin: ''
        }
    },
    authentication: {
        apimSubscriptionKey: '',
        clientId: '',
        scopes: []
    },
    hcm: {
        ui: {
            urlBase: '',
            prod: true
        }
    },
    initializing: true,
    paycorApi: {
        urlBase: ''
    },
    newRelic: {
        applicationId: '',
        licenseKey: ''
    },
    pendoApiKey: '',
    pathsWeb: {
        environment: 'local',
        clientUrl: 'http://localhost:3000',
        adminUrl: 'http://localhost:3030',
        adminServerUrl: 'http://localhost:8080',
        serverUrl: 'http://localhost:8081',
        filesUrl: 'http://localhost:8080',
        googleKey: 'AIzaSyBEOmxZAb2uMXAj_uBX_5Qa2H8LCf_ZzbU',
        algoliaAppID: 'B97CX8WUY7',
        stripePublishableAPIKey: 'pk_test_W4FoCSXBmWqdUShO7B68SZBe',
        segmentAppId: 'Y6ob0w2xLcWizS4MHtPI93SU3fai5qLN',
        refreshTokenThreshold: 60,
        // beamerProductId: 'iQuDHtks12953',
        mediaLibraryUrl: 'http://localhost:8081/media',
        mediaBucket: 'paths-dev-media',
        filesBucket: 'paths-dev-files',
        imagesBucket: 'paths-dev-images',
        sasUrl: 'http://localhost:8082',
        showCookieBanner: true,
        froalaActive: true,
        froalaKey: 'RGI4oC11C8B6F4A3H4fLUQZa1ASFe1EFRNc1He1BCCQDUHnD5D4B3D3C3D7C7C2A4C3==',
        universalAuthFlow: true,
        SAMLEnabled: true,
        pathsApiV1: '',
        demoCompanyId: '59497a389c491a000f8b711e',
        adminResourcesUrl:
            'https://paycor-digital.s3.amazonaws.com/cs-training/Admin+Resources+Page/Admin_Resources.html',
        SLACK_APP_ID: 'A023H1ZNJF9',
        SLACK_URL:
            'https://slack.com/oauth/v2/authorize?client_id=6375281205.2119067766519&scope=chat:write,chat:write.customize,im:write,links:read,links:write,team:read,users:read,users:read.email&user_scope=users:read.email,users:read',
        LICENSE_REQUEST_REPORT_URL: 'https://datastudio.google.com/reporting/3f1550a2-5492-48df-84c1-7d2511a71405',
        PATHS_LOGO_URL: 'https://hcm-quarterly.paycor.com/pds/logo/wordmark/paycor-paths.png',
        PATHS_LOGO_URL_CLOUDINARY:
            'https://res.cloudinary.com/verb-prod/image/upload/v1743697001/Logo/paycor-paths-qsb.png'
    }
});

export const RuntimeContextProvider: FunctionComponent<{
    children: ReactNode | ReactNode[];
    pathsConfiguration: PathsConfiguration;
}> = ({ children, pathsConfiguration }) => {
    return <RuntimeContext.Provider value={pathsConfiguration}>{children}</RuntimeContext.Provider>;
};

export const RuntimeContextConsumer: FunctionComponent<{
    children: (value: PathsConfiguration) => ReactNode | ReactNode[];
}> = RuntimeContext.Consumer;
